'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _service = require('./service');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var DTButton = function (_Component) {
  _inherits(DTButton, _Component);

  function DTButton() {
    _classCallCheck(this, DTButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.fetchTemplate = function () {
      var _this$props = _this.props,
          params = _this$props.params,
          getFormData = _this$props.getFormData;
      var loading = _this.state.loading;

      if (loading) {
        return;
      }

      var formData = getFormData && getFormData();
      _this.taskRunner = (0, _service.templateStatusQuery)(_extends({}, params, { formData: formData }), {
        onSuccess: _this.onSuccess,
        onError: _this.onError,
        onProgress: _this.onProgress
      });

      _this.setState({
        loading: true,
        percentage: 0,
        showDialog: true
      });
    };

    _this.onSuccess = function (res) {
      if (!res) {
        return _this.onError({});
      }
      var templateFileUrl = res.templateFileUrl,
          percentage = res.percentage;

      if (!templateFileUrl) {
        return _this.onError({ errorMsg: '未获取到模板地址' });
      }

      _this.setState({
        showDialog: true,
        templateUrl: templateFileUrl,
        percentage: percentage
      });
      setTimeout(function () {
        _this.setState({ loading: false });
      }, 500);
      _this.taskRunner = null;
      // window.open(templateFileUrl, '_blank');
    };

    _this.onError = function (err) {
      _this.taskRunner = null;
      _this.setState({
        loading: false,
        showDialog: false
      });

      // 保证 窗口消失以后再弹出消息
      setTimeout(function () {
        _next.Message.error(err.message || err.errorMsg || '下载模板失败');
      }, 500);
    };

    _this.onProgress = function (res) {
      if (!res) {
        return;
      }
      var percentage = res.percentage;

      _this.setState({
        percentage: percentage
      });
    };

    _this.onClose = function () {
      if (_this.taskRunner) {
        _this.taskRunner.abort();
        _this.taskRunner = null;
      }
      _this.setState({
        loading: false,
        showDialog: false
      });
    };

    _this.taskRunner = null;
    _this.state = {
      loading: false,
      showDialog: false,
      templateUrl: '',
      percentage: 0
    };
    return _this;
  }

  DTButton.prototype.render = function render() {
    var _state = this.state,
        loading = _state.loading,
        showDialog = _state.showDialog,
        templateUrl = _state.templateUrl,
        percentage = _state.percentage;

    if (!showDialog) {
      return _react2.default.createElement(
        _next.Button,
        { text: true, onClick: this.fetchTemplate },
        _react2.default.createElement(_next.Icon, { type: 'download' }),
        ' \u4E0B\u8F7D\u6A21\u677F'
      );
    }

    var content = loading ? _react2.default.createElement(
      'div',
      { style: { justifyContent: 'center', alignItems: 'center' } },
      _react2.default.createElement(
        'span',
        null,
        '\u52A0\u8F7D\u4E2D,\u8BF7\u7B49\u5F85\u3002'
      ),
      _react2.default.createElement(_next.Progress, { percent: percentage })
    ) : _react2.default.createElement(
      'a',
      { href: templateUrl, target: '_blank', download: true },
      '\u70B9\u51FB\u4E0B\u8F7D'
    );
    return _react2.default.createElement(
      _next.Dialog,
      {
        title: '\u6A21\u677F\u83B7\u53D6',
        visible: showDialog,
        style: { width: '360px' },
        footer: _react2.default.createElement(
          _next.Button,
          { type: 'primary', onClick: this.onClose },
          loading ? '取消下载' : '关闭'
        ),
        closeable: false
      },
      content
    );
  };

  return DTButton;
}(_react.Component);

exports.default = DTButton;
module.exports = exports['default'];